var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav-bar'),_c('div',{attrs:{"id":"wrapper"}},[_c('b-container',{attrs:{"fluid":"","id":"main-content"}},[(_vm.title)?_c('div',{staticClass:"main-title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._t("default")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }